import React from 'react';

import { Box, Typography } from '@mui/material';
import { defaultMultilineTextCellCDSProps } from '@sharedCR/coreDesignSystem/Table/TableCDS/TableCDS.constants';

import {
  FIELD_MAPPING_CHANGE_COLUMN_WIDTH,
  FIELD_MAPPING_COLUMN_LABELS,
  FieldMappingColumn,
  PDF_FIELD_KIND_LABEL,
} from '../../FormChangeHistory.constants';
import BeforeAfterLines from '../BeforeAfterLines';
import PartChangeChip from '../PartChangeChip';

import { mappedFieldCellStyles } from './PdfTemplateFacts.styles';

/** The field-mapping table; `positionLabel` says which two sides the positions compare. */
export const getFieldMappingTableConfig = positionLabel => ({
  [FieldMappingColumn.FIELD]: {
    label: FIELD_MAPPING_COLUMN_LABELS[FieldMappingColumn.FIELD],
    ...defaultMultilineTextCellCDSProps,
    content: entry => (
      <Box sx={mappedFieldCellStyles}>
        <Typography variant="medium14">{entry.label ?? entry.key}</Typography>
        <Typography color="text.secondary" variant="regular12">
          {PDF_FIELD_KIND_LABEL[entry.fieldKind] ?? entry.fieldKind}
        </Typography>
      </Box>
    ),
  },
  [FieldMappingColumn.CHANGE]: {
    label: FIELD_MAPPING_COLUMN_LABELS[FieldMappingColumn.CHANGE],
    width: FIELD_MAPPING_CHANGE_COLUMN_WIDTH,
    content: entry => <PartChangeChip change={entry.change} />,
  },
  [FieldMappingColumn.POSITION]: {
    label: positionLabel,
    ...defaultMultilineTextCellCDSProps,
    content: entry => <BeforeAfterLines lines={entry.positionLines} />,
  },
});
